import { WrapLgMarginBottom } from "App/global-style";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { CoverageCardAccordion } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/CoverageCardAccordion";
import { getInsuranceTypeCoverages } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.helpers";
import { useTexts } from "Components/TextContext";
import { Description } from "Features/CheckPrice/Products/Advice/adviceStyled";
import { AdviceCoverageName } from "Store/akaAdvice/interfaces/AkaAdviceState";
import { AkaCriticalIllness } from "Store/interfaces/products/coverage";
import { useInsuranceCoverages } from "Store/texts/hooks";
import { TextLanguage } from "Store/texts/interfaces";
import React from "react";
import { PayoutInformation } from "../../../ProductPrice/AdviceCards/PayoutInformation";
import { AkaCriticalIllnessInsuranceType } from "../../../adviceTypes";

interface Props {
  coverageGroup: AdviceCoverageName;
}

export const AkaCriticalIllnessCoverageInfo = ({
  coverageGroup,
}: Props): React.ReactElement | null => {
  const { getText } = useTexts();
  const coverageTexts = useInsuranceCoverages(
    ProductBackendName.AKA_CRITICAL_ILLNESS,
  );
  const insuranceType = AkaCriticalIllnessInsuranceType.AKA_CRITICAL_ILLNESS;
  const includedCoverages = getInsuranceTypeCoverages(
    coverageTexts,
    insuranceType,
  );

  if (
    !(Object.values(AkaCriticalIllness) as string[]).includes(coverageGroup)
  ) {
    return null;
  }

  return (
    <>
      <Description fw={700} size={"16px"}>
        {getText("advicepage.akacriticalillness.cardadvicecoverstitle")}
      </Description>
      <WrapLgMarginBottom style={{ width: "100%" }}>
        <CoverageCardAccordion
          cardId={String(coverageGroup)}
          coverages={includedCoverages}
          includedCoverages
          lang={TextLanguage.NORWEGIAN_BOKMAAL}
        />
      </WrapLgMarginBottom>
      <PayoutInformation insuranceType={insuranceType} />
    </>
  );
};
